import { http } from "../utils/http";

/**
 * Техника, SIM, аккаунты, история передач, поиск по номеру (№33) и фото сотрудников.
 * Чат 4, правка №15 (MR 3). [Claude] 2026-11-02
 */

export const getAssetCategories = () => http.get("/assets/categories");
export const createAssetCategory = ({ name, kind }) => http.post("/assets/categories", { name, kind });

export const getEmployeeAssets = (employeeId) => http.get(`/assets?employee_id=${encodeURIComponent(employeeId)}`);
export const getFreeAssets = () => http.get("/assets?free=true");
export const createAsset = (body) => http.post("/assets", body);
export const updateAsset = (assetId, body) => http.patch(`/assets/${assetId}`, body);
/** to: { type: "employee" | "department" | "workplace" | "free", employee_id?, label?, comment? } */
export const moveAsset = (assetId, to) => http.post(`/assets/${assetId}/move`, to);
export const getAssetHistory = (assetId) => http.get(`/assets/${assetId}/history`);
export const searchAssets = (q) => http.get(`/assets/search?q=${encodeURIComponent(q)}`);
export const importAssetsFromContacts = () => http.post("/assets/import-contacts", {});

export const getEmployeePhotos = (employeeId) => http.get(`/employees/${employeeId}/photos`);
export const getEmployeePhotoFile = (employeeId, photoId) => http.getBlob(`/employees/${employeeId}/photos/${photoId}/file`);
export const uploadEmployeePhoto = (employeeId, file, { caption = "", takenOn = "" } = {}) => {
    const form = new FormData();
    form.append("file", file);
    if (caption) form.append("caption", caption);
    if (takenOn) form.append("taken_on", takenOn);
    return http.post(`/employees/${employeeId}/photos`, form);
};
export const updateEmployeePhoto = (employeeId, photoId, body) => http.patch(`/employees/${employeeId}/photos/${photoId}`, body);
export const deleteEmployeePhoto = (employeeId, photoId) => http.del(`/employees/${employeeId}/photos/${photoId}`);
